import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ActionNotification } from '../../../models/notification/action-notification.model';
import { ActionNotificationService } from '../../../services/notification/action-notification.service';
import { CustomerService } from '../../../services/customer/customer.service';
import { Customer } from '../../../models/customer/customer-model'
import { UtilitiesService } from '../../../services/shared/utilities.service';

@Component({
    selector: 'app-action-notification-list',
    templateUrl: './action-notification-list.component.html',
    styleUrls: ['./action-notification-list.component.css']
})
/** action-notification-list component*/
export class ActionNotificationListComponent {
  public notificationList: ActionNotification[];
  public customerList: Customer[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  //Filter items from grid
  filteredItems: any[];
    /** action-notification-list ctor */
  constructor(
    private readonly notificationService: ActionNotificationService,
    private readonly utilitiesService: UtilitiesService,
    private readonly customerService: CustomerService) {
    this.GetActionNotifications();
    this.getVendors();
    this.GetRowsPerPageList();
  }
  GetActionNotifications() {
    this.notificationService.GetActionNotifications().subscribe(
      data => {
        this.notificationList = data
        this.filteredItems = data;
      }
    )
  }
  deleteActionNotification(id) {
    var ans = confirm("Are you sure to delete with Id: " + id);
    if (ans) {
      this.notificationService.DeleteActionNotification(id);
      setTimeout(() => {
        this.GetActionNotifications();
      }, 2000);
    }
  }
  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.notificationList, searchText);

    } else {
      this.filteredItems = this.notificationList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/action-based-notifications/action-notification-list/action-notification-list.component.ts